export const localeFR = {
	// startsWith: 'Commençant par',
	// contains: 'Contenant',
	// notContains: 'Ne contenant pas',
	// endsWith: 'Finissant par',
	// equals: 'Egal',
	// notEquals: 'Différent',
	// noFilter: 'Aucun filtre',
	// lt: 'Inférieur à',
	// lte: 'Inférieur ou égal à',
	// gt: 'Supérieur à ',
	// gte: 'Supérieur ou égal à',
	// is: 'Est',
	// isNot: 'N\'est pas',
	// before: 'Avant',
	// after: 'Après',
	// clear: 'Vider',
	// apply: 'Appliquer',
	// matchAll: 'Match All',
	// matchAny: 'Match Any',
	// addRule: 'Add Rule',
	// removeRule: 'Remove Rule',
	ok: 'Ok',
	accept: 'Oui',
	reject: 'Non',
	choose: 'Sélectionner',
	upload: 'Envoyer',
	cancel: 'Annuler',
	firstDayOfWeek: 1,
	dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
	dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	dayNamesMin: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
	monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
	monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin','Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
	today: 'Aujourd\'hui',
	clear: 'Vider',
	dateFormat: 'dd/mm/yy',
	weekHeader: 'Sem',
	weak: 'Faible',
	medium: 'Moyen',
	strong: 'Fort',
	emptyMessage: 'Aucun choix disponible',
	emptyFilterMessage: 'Aucun résultat',
	invalidFileLimitMessageDetail: '{0} fichiers maximum.',
	invalidFileLimitMessageSummary: 'Le nombre de fichiers sélectionnés dépasse la limite.',
	invalidFileSizeMessageDetail: 'maximum autorisé : {0}.',
	invalidFileSizeMessageSummary: '{0} : Taille de fichier invalide',
	invalidFileTypeMessageDetail: 'Fichiers autorisés: {0}',
	invalidFileTypeMessageSummary: '{0}: Type de fichier invalide.',
	leavingUnsavedFormConfirmHeader: 'Modifications non sauvegardées',
	leavingUnsavedFormConfirmMessage: 'Souhaitez-vous vraiment quitter la page sans sauvegarder les modifications ?',
};

export const restrictionTooltip: string = `Les restrictions permettent de définir quels groupes et utilisateurs sont <b>AUTORISÉS</b> à accéder à la ressource ou à la section. <br></br>Par défaut, quand les restrictions sont toutes vides, la ressource ou la section est réputée accessible à tout le monde. Les restrictions peuvent être définies sur les ressources, mais aussi sur les sections. <br><br>En définissant une restriction sur la ressource, celle-ci ne sera accessible qu'aux magasins/groupes/utilisateurs sélectionnés. <br></br>Un mécanisme d’héritage est implémenté. Ainsi, une personne n’ayant pas accès à une section parente n’a pas non plus accès aux ressources et sous-sections enfants de cette section (et donc, pas accès aux médias concernés).`;
